import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { PresetAmounts } from '@paypalcorp/donate-react';
import templateData from '../../utility/getTemplateData';
import * as AppActions from '../../actions/AppActions';
import AppStore from '../../stores/AppStore';
import {
  isOptInCoverFee,
  shouldSelectPresetAmount,
} from '../coverFee/feeUtils';
import { getCurrencyParts } from '../../utility/formator';
import { formatAmountFromServerDNW } from './amountUtils';
import { localsMessages } from '../../utility/getTemplateData';
import { getGriffin, __getInitialData } from '../../utility/formator';
import { trackLinkClick } from '../../fpti/fpti';
import { FPTI_TAGS, LINK_NAME } from '../../fpti/fptiConstants';

let {
  amount: { presetOther, placeholderOtherAmount },
} = localsMessages('common/amount');

function PresetAmountRow(props) {
  const getSelectedOption = () => {
    if (AppStore.getDonationAmountType() === 'preset') {
      return AppStore.getDonationAmount();
    } else if (AppStore.getDonationAmountType() === 'userinput') {
      return 'Other';
    }
    return '';
  };

  const [presetAmounts, setPresetAmounts] = useState(
      templateData.presetAmounts
    ),
    [selectedOption, setSelectedOption] = useState(getSelectedOption()),
    [showOtherAmount, setShowOtherAmount] = useState(
      AppStore.getDonationAmountType() === 'userinput' ? true : false
    );

  const handlePresetAmountClick = (value) => {
    setSelectedOption(value);
    if (value !== 'Other') {
      const selectedAmount = value;
      props.handleAmountChange(`${selectedAmount}`);
      // Highlight the selected button
      setShowOtherAmount(false);
      setPresetAmounts(templateData.presetAmounts);
      // Clear the errors from amount field
      props.hideValidationError();

      AppActions.updateDonationAmountType('preset');
    } else {
      props.handleAmountChange('');
      setShowOtherAmount(true);
    }
  };

  useEffect(() => {
    // In case user opts in for cover fee and goes back to
    // landing page from guest page, we need to restore back
    // user's original entered amount
    const amountBeforeFee = AppStore.getAmountBeforeFee();
    if (amountBeforeFee && isOptInCoverFee()) {
      if (shouldSelectPresetAmount(amountBeforeFee)) {
        handlePresetAmountClick(amountBeforeFee);
      }
    }
  }, []);

  const handleAmountChange = (amount) => {
    let checkValue = parseFloat(amount.replace(',', '.').replace(' ', ''));

    if (AppStore.getDonationAmountType() === 'preset' && checkValue > 0) {
      AppActions.updateSelectedPresetButtonId('other');
      AppActions.updateDonationAmountType('userinput');
      props.handleAmountChange('0.00');
      trackLinkClick(LINK_NAME.PRESET_AMOUNT, {
        additionalData: {
          [FPTI_TAGS.SELECTED_PRESET_BUTTON_ID]: 'other',
        },
      });
    }
    if (checkValue > 0) {
      AppActions.updateDonationAmountType('userinput');
      props.handleAmountChange(amount);
    }
  };

  const handleAmountFocus = () => {
    props.handleAmountFocus();
  };

  const getPresetOptions = (values, symbol, charityAmountCode) => {
    const [firstParts = {}] = getCurrencyParts();
    const rightSymbol = firstParts.$ !== 'symbol';
    const result = values.map((value) => {
      let amountDisplayValue;
      if (rightSymbol) {
        amountDisplayValue = symbol
          ? `${formatAmountFromServerDNW(value, charityAmountCode, {
              noDecimals: true,
            })} ${symbol}`
          : `${formatAmountFromServerDNW(value, charityAmountCode, {
              noDecimals: true,
            })}`;
      } else {
        amountDisplayValue = symbol
          ? `${symbol}${formatAmountFromServerDNW(value, charityAmountCode, {
              noDecimals: true,
            })}`
          : `${formatAmountFromServerDNW(value, charityAmountCode, {
              noDecimals: true,
            })}`;
      }
      return {
        label: amountDisplayValue,
        secondaryLabel: charityAmountCode,
        value: formatAmountFromServerDNW(value, charityAmountCode),
      };
    });
    return [...result, { label: presetOther, value: 'Other' }];
  };

  const amountFieldValue =
    AppStore.getDonationAmountType() === 'preset' ? '' : props.charityAmount;
  const presetOptions = getPresetOptions(
    presetAmounts,
    props.charityAmountSymbol,
    props.charityAmountCode
  );

  return (
    <>
      <PresetAmounts
        presetOptions={presetOptions}
        selectedOption={selectedOption}
        handlePresetAmountClick={handlePresetAmountClick}
        showOtherAmount={showOtherAmount}
        amountFieldValue={amountFieldValue}
        charityAmountSymbol={props.charityAmountSymbol}
        charityAmountCode={props.charityAmountCode}
        decimalPoint={props.decimalPoint}
        isAmountEditable={props.isAmountEditable}
        showValidationError={props.showValidationError}
        messages={{
          validationErrorMessage: props.validationErrorMessage,
          placeholderOtherAmount,
        }}
        handleAmountChange={handleAmountChange}
        handleAmountFocus={handleAmountFocus}
        amountBeforeFee={AppStore.getAmountBeforeFee()}
        griffin={getGriffin()}
        clientMetadata={__getInitialData().clientMetadata}
        coverFeeOptInStatus={AppStore.getCoverFeeOptInStatus()}
        presetAmounts={presetAmounts}
        isPreview={false}
      ></PresetAmounts>
    </>
  );
}

PresetAmountRow.propTypes = {
  hideValidationError: PropTypes.func,
  handleAmountChange: PropTypes.func,
  handleAmountFocus: PropTypes.func,
  charityAmount: PropTypes.string,
  showValidationError: PropTypes.bool,
  charityAmountSymbol: PropTypes.string,
  charityAmountCode: PropTypes.string,
  decimalPoint: PropTypes.string,
  isAmountEditable: PropTypes.bool,
  validationErrorMessage: PropTypes.string,
  validationErrorCode: PropTypes.string,
};
export default PresetAmountRow;
